export default function(icon) {
  document.getElementById("elAppleTouchIcon").setAttribute("href", `${icon.baseURL}w_72,h_72/${icon.image}`);
  document.getElementById("elAppleTouchIcon72x72").setAttribute("href", `${icon.baseURL}w_72,h_72/${icon.image}`);
  document.getElementById("elAppleTouchIcon114x114").setAttribute("href", `${icon.baseURL}w_72,h_72/${icon.image}`);
  document.getElementById("elFavicon").setAttribute("href", `${icon.baseURL}w_72,h_72/${icon.image}`);
}
